import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeadCont from "../../components/common/HeadCont";
import PersonalInfo from "../../components/account/PersonalInfo";
import TermsOfService from "../../components/account/TermsOfService";
import HealthInfoPolicy from "../../components/account/HealthInfoPolicy";
import TabCommon from "../../components/common/TabCommon";

const Policy = () => {
    const location = useLocation();
  const navigate = useNavigate();
  const initialTab = location.state?.tab || "Privacy Policy";
  const returnTo = location.state?.returnTo;
  const [tab, setTab] = useState(initialTab);
  const tabs = ["Privacy Policy", "Terms of Service", "Health Information Policy"];
  // const onCloseMenu = () => {

  //   let menu = document.querySelector("#menu")
  //   menu.scrollTo(0, 0)
  // }

  const handleBack = () => {
    if (returnTo) {
      navigate(returnTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <HeadCont
        title={"Terms & Privacy"}
        onLeftAction={handleBack}
      />
      <section className="safe-area-mt-header">
        <TabCommon tabs={tabs} setTab={setTab} tab={tab} />
        <div className="p-4">
          {tab === "Privacy Policy" ? <PersonalInfo /> :
           tab === "Terms of Service" ? <TermsOfService /> :
           <HealthInfoPolicy />}
        </div>
      </section>
    </>
  );
};

export default Policy;
